<template>
    <div id="response-filter-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Filter Responses</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div v-if="message" class="alert alert-danger" role="alert">{{ message }}</div>
                    <div class="container">
                        <div class="row">
                            <div class="col-sm">
                                <label for="statusFilter" class="my-auto">Read Status</label>
                            </div>
                            <div class="col-sm">
                                <select id="statusFilter" class="custom-select custom-select-sm my-auto" :class="['mb-3', { 'text-muted' : selectedFilters.readStatus === null }]" v-model="selectedFilters.readStatus">
                                    <option value="">Any</option>
                                    <option v-for="option in readStatusOptions" :key="'status-' + option" :value="option" v-text="option"></option>
                                </select>
                            </div>
                        </div>
                        <div class="row  my-2">
                            <div class="col-sm">
                                <label for="statusFilter" class="my-auto">Linked Status</label>
                            </div>
                            <div class="col-sm">
                                <select id="statusFilter" class="custom-select custom-select-sm my-auto" :class="['mb-3', { 'text-muted' : selectedFilters.associatedStatus === null }]" v-model="selectedFilters.associatedStatus">
                                    <option value="">Any</option>
                                    <option v-for="option in associatedStatusOptions" :key="'status-' + option" :value="option" v-text="option"></option>
                                </select>
                            </div>
                        </div>                        
                        <div class="row my-2">
                            <div class="col-sm">
                                <label for="statusFilter" class="my-auto">Owner</label>
                            </div>
                            <div class="col-sm">
                                <select id="statusFilter" class="custom-select custom-select-sm my-auto" :class="['mb-3', { 'text-muted' : selectedFilters.owner === null }]" v-model="selectedFilters.owner">
                                    <option value="">Any</option>
                                    <option v-for="option in ownerOptions" :key="'owner-' + option" :value="option" v-text="option"></option>
                                </select>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between mt-3 mb-1">
                            <label class="d-inline-flex my-auto">Received Date Range</label>
                            <div class="d-inline-flex align-items-center">
                                <input type="date" class="form-control form-control-sm" v-model="selectedFilters.received.begin">
                                <span class="mx-1">To</span>
                                <input type="date" class="form-control form-control-sm" v-model="selectedFilters.received.end">
                            </div>                                
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <a href="javascript:void(0)" class="mr-auto" @click="reset">Reset Filters</a>
                    <button type="button" class="btn btn-primary" @click="done">Done</button>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        ownerOptions: Array
    },
    data() { 
        return {
            filter: Function,
            readStatusOptions: ['Unread', 'Read'],
            associatedStatusOptions: ['Unlinked', 'Linked'],
            selectedFilters: {
                readStatus: '',
                associatedStatus: '',
                owner: '',
                received: {
                    begin: null,
                    end: null
                }
            },
            message: null
        }
    },
    methods: {
        show: function (filters, callback) {

            this.selectedFilters = JSON.parse(JSON.stringify(filters));
            this.filter = callback;
            this.message = null;

            $('#response-filter-modal').modal('show');
        },
        reset: function () {
            this.selectedFilters.readStatus = '';
            this.selectedFilters.associatedStatus = '';
            this.selectedFilters.owner = '';
            this.selectedFilters.received.begin = null;
            this.selectedFilters.received.end = null;
            this.message = null;
        },
        done: function () {
            
            if (this.selectedFilters.received.begin <= this.selectedFilters.received.end) {
                this.filter(this.selectedFilters);
                $('#response-filter-modal').modal('hide');
            }
            else { 
                this.message = 'Invalid received dated range. End date must be greater than or equal to begin data.';
            }
        }
    },
    created() {
        eventHub.$on('show-response-filters', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-response-filters');
    },
    watch: {
        'selectedFilters.received.begin': function (newValue, oldValue) {
            if (newValue != oldValue) {
                this.selectedFilters.received.end = newValue;
            }
        }
    }     
}
</script>

<style scoped>
    #statusFilter {
        vertical-align: middle !important;
    }
</style>